import { isNaN } from 'lodash-es';

function serializeSearchParams(params: any, prefix: string = '') {
  return Object.entries(params || {}).reduce((acc: string[], [key, value]: [string, any]) => {
    // 移除前后空格
    key = encodeURIComponent(key.trim());

    if (params.constructor === Array) {
      key = `${prefix}[${key}]`;
    } else if (params.constructor === Object) {
      key = (prefix ? `${prefix}[${key}]` : key);
    }

    /**
     *  - undefined 和 NaN 值将被自动跳过
     *  - 对于函数和 null，值将是空字符串
     *  - 嵌套的数组会被展平
     */
    if (value === null || typeof value === 'function') {
      acc.push(`${key}=`);
    } else if (typeof value === 'object') {
      acc = acc.concat(serializeSearchParams(value, key));
    } else if (['number', 'boolean', 'string'].includes(typeof value) && !isNaN(value)) {
      acc.push(`${key}=${encodeURIComponent(value)}`);
    }

    return acc;
  }, []);
}

export function stringifySearchParams(queryParameters: any) {
  return queryParameters ? serializeSearchParams(queryParameters).join('&'): '';
}
